/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from "prop-types";
import React from "react";

export const Text = ({ color = "#FCFCFC", className }) => {
  return (
    <svg
      className={`text ${className}`}
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path className="path" d="M13 6V21H11V6H5V4H19V6H13Z" fill={color} />
    </svg>
  );
};

Text.propTypes = {
  color: PropTypes.string,
};
